import Vue from 'vue'
import moment from 'moment-timezone'
import i18n from 'localization/index'

Vue.filter('pmlHumanDate', function (value, timezone) {
    moment.locale(i18n.locale)

    if (typeof value === 'undefined' || !moment(value).isValid()) return ''

    if (typeof timezone === 'undefined') {
        if (moment.tz.zone(window.localStorage.getItem('utcOffset')) === null)
            return moment.utc(value).utcOffset(moment.tz.guess()).fromNow()

        return moment.utc(value).utcOffset(window.localStorage.getItem('utcOffset')).fromNow()
    }

    return moment.utc(value).tz(timezone).fromNow()
})



// WEBPACK FOOTER //
// ./src/utils/filters/human-date.js